export class SignUpUser {
    username: string = ""; 
    email: string = ""; 
    password: string = ""; 
}

export class SignInUser {
    email: string = ""; 
    password: string = ""; 
}